import { useEffect } from 'react';
import { useAppDispatch } from '../../../../../../../app/redux/hooks';
import { updateYaantracVehicle } from '../../../../../../../features/yaantrac/redux/reducer/yaantracSlices/overSpeedSlice';
import { getVehicleSingleDetailsAction } from '../../../../../../../features/yaantrac/redux/reducer/yaantracSlices/vehicleList';
import { epochToDateFormat } from '../../../../../../../utils/commonFunctions';

export const useUpdateYaantracHooks = ({
  filteredRow,
  setOpen,
  reset,
  setValue
}: any) => {
  const dispatch = useAppDispatch();
  const onSubmit = async (data: any) => {
    if (filteredRow) {
      let updatePayload: any = {
        freewaySpeedLimit: data.freeWay,
        nonFreewaySpeedLimit: data.nonFreeWay,
        lastServicedDate: epochToDateFormat(Number(data?.lastServiceDate)),
        dotInspectionDate: epochToDateFormat(Number(data.dotInspectionDate)),
        insuranceExpiryDate: epochToDateFormat(Number(data.insuranceExpiryDate)),
        vehicleNumber: filteredRow?.row?.vehicleNumber,
        vehicleCategory: filteredRow?.row?.vehicleCategory,
        fuelType: filteredRow?.row?.fuelType,
        vehicleMake: filteredRow?.row?.vehicleMake,
        vehicleType: filteredRow?.row?.vehicleType,
        fuelCapacity: filteredRow?.row?.fuelCapacity,
        vehicleColor: filteredRow?.row?.vehicleColor,
        vehicleModel: filteredRow?.row?.vehicleModel,
        vehicleEngineNumber: filteredRow?.row?.vehicleEngineNumber,
        vehicleChassisNumber: filteredRow?.row?.vehicleChassisNumber,
        vehicleExpirationDate: filteredRow?.row?.vehicleExpirationDate,
        vehicleRegistrationDate: filteredRow?.row?.vehicleRegistrationDate
      };
      let payload: { updatePayload: any; id: any } = {
        updatePayload: updatePayload,
        id: filteredRow.id
      };
      await dispatch(updateYaantracVehicle({ data: payload, category: 'all' }));
      setOpen(false);
      await dispatch(getVehicleSingleDetailsAction(updatePayload.vehicleNumber));
    }
  };

  const handleClose = () => {
    reset();
    setOpen(false);
  };

  useEffect(() => {
    if (filteredRow) {
      setValue('dotInspectionDate', filteredRow?.row?.dotInspectionDate / 1000);
      setValue('insuranceExpiryDate', filteredRow?.row?.insuranceExpiryDate / 1000);
      setValue('lastServiceDate', filteredRow?.row?.lastServicedDate / 1000);
      setValue('freeWay', Number(filteredRow?.row?.freewaySpeedLimit));
      setValue('nonFreeWay', filteredRow?.row?.nonFreewaySpeedLimit);
    }
  }, [filteredRow]);

  return { onSubmit, handleClose };
};
